/**
 * 项目全局配置文件
 *
 * 通常配置项有以下:
 *    - API 前置路径
 *    - 多语言
 *    - ***
 */

// 主域名: www.baibu.la => baibu.la; www.ibaibu.com => ibaibu.com
export function getEnv(defaultEnv = 'test') {
  const defaultMainDomain = 'ibaibu.com';

  const { hostname } = window.location;
  const isLocal = /(^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$)|(^localhost$)/.test(hostname);

  const domains = hostname.split('.');
  const [levelDomain] = domains;
  const mainDomain = isLocal ? defaultMainDomain : `${domains[1]}.${domains[2]}`;

  let prefix;

  if (isLocal) {
    prefix = defaultEnv;
  }

  if (!isLocal && window?.$ibaibuEnv) {
    const { $ibaibuApiConfigMap } = window;
    // 解决蓝绿环境流量切换正确返回环境标识问题
    if (!levelDomain.startsWith('blue-') && $ibaibuApiConfigMap?.prod) {
      prefix = 'production';
    } else {
      prefix = window?.$ibaibuEnv === 'prod' ? 'production' : window?.$ibaibuEnv;
    }
    // 方便上线排查问题
    window.$ibaibuPrefix = prefix;
  }

  return {
    isLocal,
    mainDomain,
    levelDomain,
    prefix,
  };
}

// 本地开发切换环境
if (getEnv().isLocal) {
  (() => {
    const { prefix } = getEnv();
    const envMark = localStorage.getItem('envMark');
    if (!envMark || envMark !== prefix) {
      localStorage.setItem('envMark', prefix);
      window.location.reload();
    }
  })();
}

// 获取 api 前缀（线上环境）
function getApiPrefix() {
  const { $ibaibuApiConfigMap } = window;
  const [levelDomain] = window.location.hostname.split('.');
  // 解决蓝绿环境流量切换问题
  if (!levelDomain.startsWith('blue-') && $ibaibuApiConfigMap?.prod) {
    return $ibaibuApiConfigMap.prod;
  }
  if ($ibaibuApiConfigMap?.blue) {
    return $ibaibuApiConfigMap.blue;
  }
  return $ibaibuApiConfigMap;
}

// 获取 api 前置路径
export const API_BASE = getApiPrefix();

export default {
  // 多语言配置
  LANGUAGES: [
    { name: '中文简体', lang: 'zh' },
    { name: 'English', lang: 'en' },
  ],
};
